import { render, staticRenderFns } from "./AddBatchImport.vue?vue&type=template&id=37d49894&scoped=true&"
import script from "./AddBatchImport.vue?vue&type=script&lang=js&"
export * from "./AddBatchImport.vue?vue&type=script&lang=js&"
import style0 from "./AddBatchImport.vue?vue&type=style&index=0&id=37d49894&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d49894",
  null
  
)

export default component.exports